
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app_guide",
      function () {
        return require("private-next-pages/app_guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app_guide"])
      });
    }
  